import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import Grid from "@material-ui/core/Grid";

import NoticeIcon from "../../../../Assets/Logo/NoticeIcon.svg";
import { url } from "../../../../Config/Config";
import { useStyles } from "../UserDashboard.css";
import UserDashboardCard from "../UserDashboardCard/UserDashboardCard";
import TeacherAttendanceCard from "./TeacherAttendanceCard/TeacherAttendanceCard";
import { getUserRefreshToken } from "../../../../Redux/Actions/actions";

class TeacherDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          label: "Total Notice this month",
          count: 0,
          url: "/notices",
          icon: (
            <img
              src={NoticeIcon}
              alt="Notices"
              style={{ width: 50, height: 50 }}
            />
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getTeacherDashboard();
  }

  getTeacherDashboard = async () => {
    try {
      const noticeResponse = await Axios.get(`${url}/api/notices`, {
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      let filterNotice = noticeResponse.data.notices.filter((data) => {
        return (
          moment(data.createdAt).format("YYYY") ===
            moment(new Date()).format("YYYY") &&
          moment(data.createdAt).format("MM") ===
            moment(new Date()).format("MM")
        );
      });
      this.setCount("Total Notice this month", filterNotice.length);
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getTeacherDashboard();
      }
    }
  };

  setCount = (label, tempCount) => {
    let newArray;
    newArray = this.state.data.map((data) =>
      data.label === label
        ? { ...data, count: tempCount }
        : { ...data, count: data.count }
    );
    this.setState({
      data: newArray,
    });
  };

  render() {
    return (
      <div>
        <Grid container spacing={3}>
          {this.state.data.map((data, index) => (
            <UserDashboardCard
              key={index}
              url={data.url}
              label={data.label}
              count={data.count}
              icon={data.icon}
            />
          ))}
          <TeacherAttendanceCard />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(TeacherDashboard));
